<template>
  <div class="calendar-options-setting">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')" title="外观" name="2">
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
          >
            <div class="content">
              <div class="content-item mb16">
                <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
              </div>
              <div class="content-item mb16">
                <border-radius
                  :borderTypeFlag.sync="borderTypeFlag"
                  :borderRadius.sync="borderRadius"
                  :borderTopLeftRadius.sync="borderTopLeftRadius"
                  :borderTopRightRadius.sync="borderTopRightRadius"
                  :borderBottomRightRadius.sync="borderBottomRightRadius"
                  :borderBottomLeftRadius.sync="borderBottomLeftRadius"
                />
              </div>
              <div class="content-item mb16">
                <div class="checkbox_colorPicker_container">
                  <label>边框</label>
                </div>
                <div class="verticallyCenter">
                  <cx-border
                    :borderWidth.sync="borderWidth"
                    :borderStyle.sync="borderStyle"
                    :borderColor.sync="borderColor"
                    :borderIsThemeColor.sync="borderIsThemeColor"
                  />
                </div>
              </div>
              <div class="content-item mb16">
                <cx-padding
                  :paddingTypeFlag.sync="paddingTypeFlag"
                  :padding.sync="padding"
                  :paddingTop.sync="paddingTop"
                  :paddingRight.sync="paddingRight"
                  :paddingBottom.sync="paddingBottom"
                  :paddingLeft.sync="paddingLeft"
                />
              </div>
              <div class="content-item mb16">
                <slider-and-input
                    :value.sync="columnMargin"
                    :sliderMax="sliderMax"
                    suffix="px"
                    class="mt16"
                    className="grid_home edge_2"
                    inputWidth="small"
                    inputHeight="small"
                    title="列间距"
                />
              </div>
              <cx-background :background.sync="background" imgType="10" class="mt16" />
              <div class="content-item mt16">
                <div class="checkbox_colorPicker_container">
                  <span>阴影</span>
                  <span
                    v-show="borderShadowChecked"
                    class="icon-portal-plus theme-color right-icon"
                    @click="addBoxshadow"
                  ></span>
                </div>
                <box-shadow
                  v-show="borderShadowChecked"
                  :boxShadowH.sync="boxShadowH"
                  :boxShadowV.sync="boxShadowV"
                  :boxShadowBlur.sync="boxShadowBlur"
                  :boxShadowSpread.sync="boxShadowSpread"
                  :boxShadowColor.sync="boxShadowColor"
                ></box-shadow>
              </div>
              <div class="content-item mt16">
                <public-style :options="options" :ids="ids"></public-style>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
          title="标题样式"
          name="3"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')"
          >
            <div class="content-item mb16">
              <cx-check-box :value.sync="showTitle">显示日历标题</cx-check-box>
            </div>
            <div class="content" v-if="showTitle">
              <div class="content-item mb16" v-if="styleId === 1">
                <div class="verticallyCenter">
                  <span class="font14 mr10 mb10" style="width: 57px">标题格式</span>
                  <el-select popper-class="date-style-select" class="mb10" v-model="dateStyle" placeholder="请选择">
                    <el-option v-for="item in dateOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="content-item mb16" v-if="styleId === 2">
                <p class="font14 mb8">下拉框宽度</p>
                <slider-and-input :value.sync="selectWidth" title="" :sliderMax="selectWidthMax" suffix="px" />
              </div>
              <div class="content-item mb16">
                <!-- 字体和颜色/字重和字号 -->
                <text-setting-complex-update
                  class="mb16"
                  :fontFamily.sync="titleFontFamily"
                  :fontSize.sync="titleFontSize"
                  :fontWeight.sync="titleFontWeight"
                  :fontStyle.sync="titleFontStyle"
                  :textDecoration.sync="titleTextDecoration"
                  :lineHeight.sync="titleLineHeight"
                  :lineHeightType.sync="titleLineHeightType"
                  :letterSpacing.sync="titleLetterSpacing"
                  :activeArrangement.sync="titleActiveArrangement"
                  :writingMode.sync="titleWritingMode"
                  :textAlign.sync="titleTextAlign"
                  :activeArrangementOrder.sync="titleActiveArrangementOrder"
                  :isThemeColor.sync="titleTextIsThemeColor"
                  :colorArr.sync="titleColor"
                  :options="options"
                />
                <div v-if="styleId === 2" class="verticallyCenter mb16">
                  <span class="fs14 mr16">下拉框背景色</span>
                  <cx-color-picker
                    class="custom-title-color flex1"
                    :isThemeColor.sync="topSelectBgColorIsThemeColor"
                    :colorArr.sync="topSelectBgColor"
                  ></cx-color-picker>
                </div>
                <div class="verticallyCenter mb16">
                  <span class="fs14 mr16">背景颜色</span>
                  <cx-color-picker
                    class="custom-title-color"
                    :isThemeColor.sync="titleBgColorIsThemeColor"
                    :colorArr.sync="titleBgColor"
                  ></cx-color-picker>
                </div>
                <div class="content-item mb16">
                  <cx-padding
                    :paddingTypeFlag.sync="titlePaddingTypeFlag"
                    :padding.sync="titlePadding"
                    :paddingTop.sync="titlePaddingTop"
                    :paddingRight.sync="titlePaddingRight"
                    :paddingBottom.sync="titlePaddingBottom"
                    :paddingLeft.sync="titlePaddingLeft"
                  />
                </div>
              </div>
              <div v-if="styleId === 2">
                <p class="">下拉列表项</p>
                <!--<div class="content-item mb16">
                  <slider-and-input :value.sync="selectlistsHeight" title="列表高度" :sliderMax="400" suffix="px" />
                </div>-->
                <div class="content-item mb16">
                  <slider-and-input :value.sync="selectOptionsHeight" title="单行高度" :sliderMax="100" suffix="px" />
                </div>

                <div class="content-item mb16">
                  <border-radius
                    :borderTypeFlag.sync="titleBorderTypeFlag"
                    :borderRadius.sync="titleBorderRadius"
                    :borderTopLeftRadius.sync="titleBorderTopLeftRadius"
                    :borderTopRightRadius.sync="titleBorderTopRightRadius"
                    :borderBottomRightRadius.sync="titleBorderBottomRightRadius"
                    :borderBottomLeftRadius.sync="titleBorderBottomLeftRadius"
                    :sliderMax="100"
                  />
                </div>
                <div class="content-item mb16">
                  <div class="checkbox_colorPicker_container">
                    <label>边框</label>
                  </div>
                  <div class="verticallyCenter">
                    <cx-border
                      :borderWidth.sync="titleBorderWidth"
                      :borderStyle.sync="titleBorderStyle"
                      :borderColor.sync="titleBorderColor"
                      :borderIsThemeColor.sync="titleBorderIsThemeColor"
                    />
                  </div>
                </div>
                <div class="content-item mb16">
                  <cx-padding
                    :paddingTypeFlag.sync="titlePaddingTypeFlag2"
                    :padding.sync="titlePadding2"
                    :paddingTop.sync="titlePaddingTop2"
                    :paddingRight.sync="titlePaddingRight2"
                    :paddingBottom.sync="titlePaddingBottom2"
                    :paddingLeft.sync="titlePaddingLeft2"
                    :sliderMax="100"
                  />
                </div>
                <div class="content-item mb16">
                  <div class="verticallyCenter">
                    <span class="fs14 mr16">背景颜色</span>
                    <cx-color-picker
                      class="custom-title-color flex1"
                      :isThemeColor.sync="titleSelectBgIsThemeColor"
                      :colorArr.sync="titleSelectBgColor"
                    ></cx-color-picker>
                  </div>
                </div>
                <div class="content-item mt16">
                  <div class="checkbox_colorPicker_container">
                    <span>阴影</span>
                    <span
                      v-show="titleBorderShadowChecked"
                      class="icon-portal-plus theme-color right-icon"
                      @click="titleAddBoxshadow"
                    ></span>
                  </div>
                  <box-shadow
                    v-show="titleBorderShadowChecked"
                    :boxShadowH.sync="titleBoxShadowH"
                    :boxShadowV.sync="titleBoxShadowV"
                    :boxShadowBlur.sync="titleBoxShadowBlur"
                    :boxShadowSpread.sync="titleBoxShadowSpread"
                    :boxShadowColor.sync="titleBoxShadowColor"
                  ></box-shadow>
                </div>

                <el-tabs v-model="activeStatusTitle" class="date-state-set mt16">
                  <el-tab-pane label="默认" name="statusTitle0">
                    <div class="content-item mb16">
                      <p class="font14 mb16 mt16">文字样式</p>
                      <text-setting-update
                        :fontColor.sync="titleSelectColor"
                        :fontFamily.sync="titleSelectFontFamily"
                        :fontSize.sync="titleSelectFontSize"
                        :fontWeight.sync="titleSelectFontWeight"
                      />
                    </div>
                    <div class="content-item mb16">
                      <div class="verticallyCenter">
                        <span class="fs14 mr16">背景</span>
                        <cx-color-picker
                          class="custom-title-color flex1"
                          :isThemeColor.sync="titleSelectOptionsBgIsThemeColor"
                          :colorArr.sync="titleSelectOptionsBgColor"
                        ></cx-color-picker>
                      </div>
                    </div>
                  </el-tab-pane>
                  <!-- 悬停同选中 -->
                  <el-tab-pane label="选中" name="statusTitle2">
                    <div class="content-item mb16">
                      <p class="font14 mb16 mt16">文字样式</p>
                      <text-setting-update
                        :fontColor.sync="titleSelectActiveColor"
                        :fontFamily.sync="titleSelectActiveFontFamily"
                        :fontSize.sync="titleSelectActiveFontSize"
                        :fontWeight.sync="titleSelectActiveFontWeight"
                      />
                    </div>
                    <div class="content-item mb16">
                      <div class="verticallyCenter">
                        <span class="fs14 mr16">背景</span>
                        <cx-color-picker
                          class="custom-title-color flex1"
                          :isThemeColor.sync="titleSelectActiveBgIsThemeColor"
                          :colorArr.sync="titleSelectActiveBgColor"
                        ></cx-color-picker>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')"
          title="星期样式"
          name="4"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')"
          >
            <div class="content">
              <div class="content-item mb16 firstDayOfWeek-set">
                <span class="font14 mr12 label">起始日</span>
                <el-tabs v-model="activeStart" @tab-click="changeStartFn">
                  <el-tab-pane label="星期日" name="start0"></el-tab-pane>
                  <el-tab-pane label="星期一" name="start1"></el-tab-pane>
                </el-tabs>
              </div>
              <div class="content-item mb16">
                <p class="font14 mb16 mt16">文字样式</p>
                <text-setting-update
                  :fontColor.sync="weekColor"
                  :fontFamily.sync="weekFontFamily"
                  :fontSize.sync="weekFontSize"
                  :fontWeight.sync="weekFontWeight"
                />
              </div>
              <div class="content-item mb16">
                <div class="verticallyCenter mb16">
                  <span class="fs14 mr16">背景颜色</span>
                  <cx-color-picker
                    class="custom-title-color"
                    :isThemeColor.sync="weekBgColorIsThemeColor"
                    :colorArr.sync="weekBgColor"
                  ></cx-color-picker>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
          title="日期样式"
          name="5"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')"
          >
            <div class="content">
              <el-tabs v-model="activeStatus" class="date-state-set">
                <el-tab-pane label="默认" name="status0">
                  <div class="content-item mb16">
                    <p class="font14 mb16 mt16">文字样式</p>
                    <text-setting-update
                      :fontColor.sync="color"
                      :fontFamily.sync="fontFamily"
                      :fontSize.sync="fontSize"
                      :fontWeight.sync="fontWeight"
                    />
                  </div>
                  <div class="content-item mb16">
                    <cx-check-box :value.sync="showLunar">显示农历</cx-check-box>
                  </div>
                  <div class="content-item mb16" v-if="showLunar">
                    <text-setting-update
                      :fontColor.sync="lunarColor"
                      :fontFamily.sync="lunarFontFamily"
                      :fontSize.sync="lunarFontSize"
                      :fontWeight.sync="lunarFontWeight"
                    />
                  </div>
                  <div class="content-item mb16">
                    <cx-check-box :value.sync="showNotCurrentDate">显示非本月日期</cx-check-box>
                  </div>
                  <div class="content-item mb16" v-if="showNotCurrentDate">
                    <div class="verticallyCenter">
                      <span class="fs14 mr16">颜色</span>
                      <cx-color-picker
                        class="custom-title-color flex1"
                        :isThemeColor.sync="notCurrentTextIsThemeColor"
                        :colorArr.sync="notCurrentTextColor"
                      ></cx-color-picker>
                    </div>
                  </div>
                  <div class="content-item mb16" v-if="styleId === 3">
                    <border-radius
                        :borderTypeFlag.sync="dayBorderTypeFlag"
                        :borderRadius.sync="dayBorderRadius"
                        :borderTopLeftRadius.sync="dayBorderTopLeftRadius"
                        :borderTopRightRadius.sync="dayBorderTopRightRadius"
                        :borderBottomRightRadius.sync="dayBorderBottomRightRadius"
                        :borderBottomLeftRadius.sync="dayBorderBottomLeftRadius"
                    />
                  </div>
                  <div class="content-item mb16" v-if="styleId === 3">
                    <div class="checkbox_colorPicker_container mb16">
                      <cx-check-box :value.sync="showDayBorder">显示边框</cx-check-box>
                    </div>
                    <div class="verticallyCenter date-border-box" v-if="showDayBorder">
                      <span class="fs14 mr16">颜色</span>
                      <cx-color-picker
                          class="custom-title-color flex1"
                          :isThemeColor.sync="dayBorderIsThemeColor"
                          :colorArr.sync="dayBorderColor"
                      ></cx-color-picker>
                    </div>
                  </div>
                  <div class="content-item mb16" v-if="styleId === 3">
                    <div class="verticallyCenter">
                      <span class="fs14 mr16">背景颜色</span>
                      <cx-color-picker
                          class="custom-title-color"
                          :isThemeColor.sync="dayBgColorIsThemeColor"
                          :colorArr.sync="dayBgColor"
                      ></cx-color-picker>
                    </div>
                  </div>
                  <div class="content-item mb16">
                    <div class="border-radius-header mb16 fs14">上下边距</div>
                    <div class="setting-item-grid home">
                      <slider-and-input
                        :value.sync="datePaddingTopVal"
                        :sliderMax="sliderMax"
                        suffix="px"
                        class="mt16"
                        className="grid_home edge_2"
                        inputWidth="small"
                        inputHeight="small"
                        tips="上边距"
                      />
                      <slider-and-input
                        :value.sync="datePaddingBottomVal"
                        :sliderMax="sliderMax"
                        suffix="px"
                        class="mt16"
                        className="grid_home edge_4"
                        inputWidth="small"
                        inputHeight="small"
                        tips="下边距"
                      />
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="悬浮" name="status1">
                  <div class="content-item mb16">
                    <p class="font14 mb16 mt16">文字样式</p>
                    <text-setting-update
                      :fontColor.sync="hoverColor"
                      :fontFamily.sync="hoverFontFamily"
                      :fontSize.sync="hoverFontSize"
                      :fontWeight.sync="hoverFontWeight"
                    />
                  </div>
                  <div class="content-item mb16" v-if="showLunar">
                    农历样式
                  </div>
                  <div class="content-item mb16" v-if="showLunar">
                    <text-setting-update
                      :fontColor.sync="lunarHoverColor"
                      :fontFamily.sync="lunarHoverFontFamily"
                      :fontSize.sync="lunarHoverFontSize"
                      :fontWeight.sync="lunarHoverFontWeight"
                    />
                  </div>
                  <div class="content-item mb16">
                    <border-radius
                      :borderTypeFlag.sync="hoverBorderTypeFlag"
                      :borderRadius.sync="hoverBorderRadius"
                      :borderTopLeftRadius.sync="hoverBorderTopLeftRadius"
                      :borderTopRightRadius.sync="hoverBorderTopRightRadius"
                      :borderBottomRightRadius.sync="hoverBorderBottomRightRadius"
                      :borderBottomLeftRadius.sync="hoverBorderBottomLeftRadius"
                    />
                  </div>
                  <div class="content-item mb16">
                    <div class="checkbox_colorPicker_container mb16">
                      <cx-check-box :value.sync="showHoverBorder">显示边框</cx-check-box>
                    </div>
                    <div class="verticallyCenter date-border-box" v-if="showHoverBorder">
                      <span class="fs14 mr16">颜色</span>
                      <cx-color-picker
                        class="custom-title-color flex1"
                        :isThemeColor.sync="hoverBorderIsThemeColor"
                        :colorArr.sync="hoverBorderColor"
                      ></cx-color-picker>
                    </div>
                  </div>
                  <div class="content-item mb16">
                    <div class="verticallyCenter">
                      <span class="fs14 mr16">背景颜色</span>
                      <cx-color-picker
                        class="custom-title-color"
                        :isThemeColor.sync="hoverBgColorIsThemeColor"
                        :colorArr.sync="hoverBgColor"
                      ></cx-color-picker>
                    </div>
                  </div>
                  <div class="content-item mb16" v-if="isAdmin && styleId !== 3">
                    <div class="verticallyCenter">
                      <span class="fs14 mr16">外层背景</span>
                      <cx-color-picker
                        class="custom-title-color"
                        :isThemeColor.sync="hoverAllBgColorIsThemeColor"
                        :colorArr.sync="hoverAllBgColor"
                      ></cx-color-picker>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="选中" name="status2">
                  <div class="content-item mb16">
                    <p class="font14 mb16 mt16">文字样式</p>
                    <text-setting-update
                      :fontColor.sync="activeColor"
                      :fontFamily.sync="activeFontFamily"
                      :fontSize.sync="activeFontSize"
                      :fontWeight.sync="activeFontWeight"
                    />
                  </div>
                  <div class="content-item mb16" v-if="showLunar">
                    农历样式
                  </div>
                  <div class="content-item mb16" v-if="showLunar">
                    <text-setting-update
                      :fontColor.sync="lunarActiveColor"
                      :fontFamily.sync="lunarActiveFontFamily"
                      :fontSize.sync="lunarActiveFontSize"
                      :fontWeight.sync="lunarActiveFontWeight"
                    />
                  </div>
                  <div class="content-item mb16">
                    <border-radius
                      :borderTypeFlag.sync="activeBorderTypeFlag"
                      :borderRadius.sync="activeBorderRadius"
                      :borderTopLeftRadius.sync="activeBorderTopLeftRadius"
                      :borderTopRightRadius.sync="activeBorderTopRightRadius"
                      :borderBottomRightRadius.sync="activeBorderBottomRightRadius"
                      :borderBottomLeftRadius.sync="activeBorderBottomLeftRadius"
                    />
                  </div>
                  <div class="content-item mb16">
                    <div class="checkbox_colorPicker_container mb16">
                      <cx-check-box :value.sync="showActiveBorder">显示边框</cx-check-box>
                    </div>
                    <div class="verticallyCenter date-border-box" v-if="showActiveBorder">
                      <span class="fs14 mr16">颜色</span>
                      <cx-color-picker
                        class="custom-title-color flex1"
                        :isThemeColor.sync="activeBorderIsThemeColor"
                        :colorArr.sync="activeBorderColor"
                      ></cx-color-picker>
                    </div>
                  </div>
                  <div class="content-item mb16">
                    <div class="verticallyCenter">
                      <span class="fs14 mr16">背景颜色</span>
                      <cx-color-picker
                        class="custom-title-color"
                        :isThemeColor.sync="activeBgColorIsThemeColor"
                        :colorArr.sync="activeBgColor"
                      ></cx-color-picker>
                    </div>
                  </div>
                  <div class="content-item mb16" v-if="isAdmin && styleId !== 3">
                    <div class="verticallyCenter">
                      <span class="fs14 mr16">外层背景</span>
                      <cx-color-picker
                        class="custom-title-color"
                        :isThemeColor.sync="activeAllBgColorIsThemeColor"
                        :colorArr.sync="activeAllBgColor"
                      ></cx-color-picker>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
          title="今日样式"
          name="6"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '6')"
          >
            <div class="content-item mb16">
              <cx-check-box :value.sync="showTodayStyle">显示今日</cx-check-box>
            </div>
            <div class="content" v-if="showTodayStyle">
              <div class="content-item mb16">
                <p class="font14 mb16 mt16">文字样式</p>
                <text-setting-update
                  :fontColor.sync="todayStyleColor"
                  :fontFamily.sync="todayStyleFontFamily"
                  :fontSize.sync="todayStyleFontSize"
                  :fontWeight.sync="todayStyleFontWeight"
                />
              </div>
              <div class="content-item mb16 todayLunarType-set">
                <p class="font14 mb8 label">提示文字样式</p>
                <el-tabs v-model="activeLunar" @tab-click="changeLunarFn">
                  <el-tab-pane label="默认" name="start0"></el-tab-pane>
                  <el-tab-pane label="自定义" name="start1"></el-tab-pane>
                  <el-tab-pane label="无" name="start2"></el-tab-pane>
                </el-tabs>
              </div>
              <div class="content-item mb16" v-if="activeLunar === 'start1'">
                <el-input v-model="selfLunarTxt" placeholder="请输入自定义内容"></el-input>
              </div>
              <div class="content-item mb16" v-if="activeLunar === 'start1'">
                <text-setting-update
                    :fontColor.sync="todayLunarStyleColor"
                    :fontFamily.sync="todayLunarStyleFontFamily"
                    :fontSize.sync="todayLunarStyleFontSize"
                    :fontWeight.sync="todayLunarStyleFontWeight"
                />
              </div>
              <div class="content-item mb16">
                <border-radius
                  :borderTypeFlag.sync="todayStyleBorderTypeFlag"
                  :borderRadius.sync="todayStyleBorderRadius"
                  :borderTopLeftRadius.sync="todayStyleBorderTopLeftRadius"
                  :borderTopRightRadius.sync="todayStyleBorderTopRightRadius"
                  :borderBottomRightRadius.sync="todayStyleBorderBottomRightRadius"
                  :borderBottomLeftRadius.sync="todayStyleBorderBottomLeftRadius"
                />
              </div>
              <div class="content-item mb16">
                <div class="checkbox_colorPicker_container mb16">
                  <cx-check-box :value.sync="showTodayStyleBorder">显示边框</cx-check-box>
                </div>
                <div class="verticallyCenter date-border-box" v-if="showTodayStyleBorder">
                  <span class="fs14 mr16">颜色</span>
                  <cx-color-picker
                    class="custom-title-color flex1"
                    :isThemeColor.sync="todayStyleBorderIsThemeColor"
                    :colorArr.sync="todayStyleBorderColor"
                  ></cx-color-picker>
                </div>
              </div>
              <div class="content-item mb16">
                <div class="verticallyCenter">
                  <span class="fs14 mr16">背景颜色</span>
                  <cx-color-picker
                    class="custom-title-color"
                    :isThemeColor.sync="todayStyleBgColorIsThemeColor"
                    :colorArr.sync="todayStyleBgColor"
                  ></cx-color-picker>
                </div>
              </div>
              <div class="content-item mb16" v-if="isAdmin && styleId !== 3">
                <div class="verticallyCenter">
                  <span class="fs14 mr16">外层背景</span>
                  <cx-color-picker
                    class="custom-title-color"
                    :isThemeColor.sync="todayAllBgColorIsThemeColor"
                    :colorArr.sync="todayAllBgColor"
                  ></cx-color-picker>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"
          title="活动标记样式"
          name="7"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '7')"
          >
            <div class="content-item mb16">
              <cx-check-box :value.sync="showActivityMark">显示活动标记</cx-check-box>
            </div>
            <div v-if="showActivityMark">
              <div class="content-item mb16 verticallyCenter">
                <span class="fs14 mr16">大小</span>
                <slider-and-input
                  class="small-width widthPer77"
                  :value.sync="activityWidth"
                  :sliderMax="activityMaxWidth"
                  suffix="px"
                  inputWidth="small"
                  inputHeight="small"
                />
              </div>
              <!-- 活动标记的圆角 -->
              <div class="content-item mb16 verticallyCenter">
                <span class="fs14 mr16">圆角</span>
                <slider-and-input
                  class="small-width widthPer77"
                  :value.sync="activityBorderRadius"
                  :sliderMax="activityWidth"
                  suffix="px"
                  inputWidth="small"
                  inputHeight="small"
                />
              </div>
              <div class="content-item mb16 verticallyCenter" v-if="styleId === 2">
                <span class="font14 mr16 mb10">位置</span>
                <el-select
                  popper-class="activity-location-select"
                  class="mb10"
                  v-model="activityLocation"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in activityLocationOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <pagination-set
                  v-if="styleId === 3"
                  class="mt8 ml8"
                  :paginationPosition.sync="activityLocation3"
                  :paginationLeft.sync="activityLeft"
                  :paginationRight.sync="activityRight"
                  :paginationTop.sync="activityTop"
                  :paginationBottom.sync="activityBottom"
              />
              <p>本月标记样式</p>
              <div class="padding12 content-item-2">
                <div class="content-item mb16">
                  <p class="font14 mb16">文字样式</p>
                  <text-setting-update
                    :fontColor.sync="activityFontColor"
                    :fontFamily.sync="activityFontFamily"
                    :fontSize.sync="activityFontSize"
                    :fontWeight.sync="activityFontWeight"
                  />
                </div>
                <div class="content-item mb16">
                  <div class="verticallyCenter">
                    <span class="fs14 mr16">背景色</span>
                    <cx-color-picker
                      class="custom-title-color custom-title-color-card"
                      :isThemeColor.sync="activityBgColorIsThemeColor"
                      :colorArr.sync="activityBgColor"
                    ></cx-color-picker>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="content acvtivity-box" v-if="showActivityMark">
              <div class="content-item mb16 verticallyCenter">
                <span class="fs14 mr16">大小</span>
                <slider-and-input
                  :value.sync="activityWidth"
                  :sliderMax="8"
                  suffix="px"
                  inputWidth="small"
                  inputHeight="small"
                />
              </div>
              <div class="content-item mb16">
                <div class="verticallyCenter">
                  <span class="fs14 mr16">背景颜色</span>
                  <cx-color-picker
                    class="custom-title-color"
                    :isThemeColor.sync="activityColorIsThemeColor"
                    :colorArr.sync="activityColor"
                  ></cx-color-picker>
                </div>
              </div>
            </div> -->
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')"
          title="切换按钮"
          name="8"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '8')"
          >
            <Button :ids="ids" :options="options" />
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '9')"
          title="图例"
          name="9"
          v-if="styleId !== 3"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '9')"
          >
            <CalendarLegend :ids="ids" :options="options" />
          </div>
        </el-collapse-item>
        <el-collapse-item
          v-show="$store.state.states.showPluginSetting"
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '10')"
          title="插件"
          name="10"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '10')"
          >
            <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"
import button from "./settings/button.vue"
import calendarLegend from "./settings/calendarLegend.vue"
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
import { withMethodsHistoryCombine } from "utils/revork"
import publicStyle from "publicSetting/publicStyle.vue"
export default withMethodsHistoryCombine({
  name: "calendar-options-setting",
  components: {
    controlWidthAndSizeAndZindex,
    widthAndSizeAndZindex,
    Button: button,
    CalendarLegend: calendarLegend,
    elementPluginSetting,
    publicStyle
  },
  props: { options: Object },
  data() {
    return {
      isAdmin: false,
      activeNames: ["1", "2"],
      collapseActiveNames: ["1", "2"],
      allCollapseNames: ["3", "4", "5", "6", "7", "8", "9"],
      borderShadowChecked: true,
      dateOptions: [
        {
          value: "1",
          label: "2021年11月"
        },
        {
          value: "2",
          label: "2021年 十一月"
        },
        {
          value: "3",
          label: "2021-11"
        },
        {
          value: "4",
          label: "2021 / 11"
        }
      ],
      activeStatus: "status0",
      activeStart: "start0",
      sliderMax: 100,
      // activeMark: "type0",
      activeStatusTitle: "statusTitle0",
      titleBorderShadowChecked: true,
      activityLocationOptions: [
        {
          value: "1",
          label: "顶部居左"
        },
        {
          value: "2",
          label: "顶部居中"
        },
        {
          value: "3",
          label: "顶部居右"
        },
        {
          value: "4",
          label: "底部居左"
        },
        {
          value: "5",
          label: "底部居中"
        },
        {
          value: "6",
          label: "底部居右"
        }
      ],
      activityMaxWidth: 8,
      selectWidthMax: 500,
      activeLunar: "start0"
    }
  },
  watch: {
    styleId(n, o) {
      if (n !== o) {
       if(n === 1){
         this.activityMaxWidth = 8
       }else if(n === 2){
         this.activityMaxWidth = 50
       }else if(n === 3){
         this.activityMaxWidth = 20
       }
      }
    },
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    styleId() {
      return this.options.styleId || 1
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    color: {
      get() {
        return this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.bgColorIsThemeColor,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "background", false)
      }
    },
    bgColorIsThemeColor: {
      get() {
        return this.options.bgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColorIsThemeColor", false)
      }
    },
    imgSrc: {
      get() {
        return this.options.imgSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "imgSrc", false)
      }
    },
    opacity: {
      get() {
        return this.options.opacity * 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal / 100, "opacity", false)
      }
    },
    borderTypeFlag: {
      get() {
        return this.options.borderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return this.options.borderRadius
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.$changeOptionsEV(
            [newVal, newVal, newVal, newVal, newVal],
            [
              "borderTopLeftRadius",
              "borderTopRightRadius",
              "borderBottomLeftRadius",
              "borderBottomRightRadius",
              "borderRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "borderRadius", false)
        }
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.options.borderTopLeftRadius || 0
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.$changeOptionsEV(
            [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
            ["borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius", "borderTopLeftRadius"],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
        }
      }
    },
    borderTopRightRadius: {
      get() {
        return this.options.borderTopRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.options.borderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.options.borderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderWidth: {
      get() {
        return this.options.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.options.borderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.boxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    // 边距
    paddingTypeFlag: {
      get() {
        let defaultType = 2
        if (((this.paddingTop === this.paddingRight) === this.paddingLeft) === this.paddingBottom) {
          defaultType = 1
        }
        return this.options.paddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    showTitle: {
      get() {
        return this.options.showTitle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showTitle", false)
      }
    },
    dateStyle: {
      get() {
        return this.options.dateStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dateStyle", false)
      }
    },
    titleFontFamily: {
      get() {
        return this.options.titleFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleFontFamily", false)
      }
    },
    titleFontSize: {
      get() {
        return this.options.titleFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleFontSize", false)
      }
    },
    titleFontWeight: {
      get() {
        return this.options.titleFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleFontWeight", false)
      }
    },
    titleFontStyle: {
      get() {
        return this.options.titleFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleFontStyle", false)
      }
    },
    titleTextDecoration: {
      get() {
        return this.options.titleTextDecoration || "none"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleTextDecoration", false)
      }
    },
    titleLineHeight: {
      get() {
        return this.options.titleLineHeight || 50
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleLineHeight", false)
      }
    },
    titleLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titleLineHeightType", "titleLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleLineHeightType", false)
      }
    },
    titleLetterSpacing: {
      get() {
        return this.options.titleLetterSpacing || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleLetterSpacing", false)
      }
    },
    titleWritingMode: {
      get() {
        return this.options.titleWritingMode || "horizontal-tb"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleWritingMode", false)
      }
    },
    titleTextAlign: {
      get() {
        return this.options.titleTextAlign || "center"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleTextAlign", false)
      }
    },
    titleActiveArrangement() {
      return this.options.titleTextAlign || "left"
    },
    titleActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.titleWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "titleWritingMode", false)
      }
    },
    titleTextIsThemeColor: {
      get() {
        return this.options.titleTextIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleTextIsThemeColor", false)
      }
    },
    titleColor: {
      get() {
        return this.options.titleColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleColor", false)
      }
    },

    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.options.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontWeight", false)
      }
    },
    fontStyle: {
      get() {
        return this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontStyle", false)
      }
    },
    textDecoration: {
      get() {
        return this.options.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textDecoration", false)
      }
    },
    lineHeight: {
      get() {
        return this.options.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeight", false)
      }
    },
    letterSpacing: {
      get() {
        return this.options.letterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacing", false)
      }
    },
    writingMode: {
      get() {
        return this.options.writingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "writingMode", false)
      }
    },
    textAlign: {
      get() {
        return this.options.textAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textAlign", false)
      }
    },
    letterSpacingType: {
      get() {
        return this.options.letterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacingType", false)
      }
    },
    activeArrangement() {
      return this.options.textAlign
    },
    activeArrangementOrder: {
      get() {
        return {
          label: "竖排文字",
          _class: "icon-portal-text-down1",
          isActive: this.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.writingMode = val
      }
    },
    textIsThemeColor: {
      get() {
        return this.options.textIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIsThemeColor", false)
      }
    },
    titleBgColorIsThemeColor: {
      get() {
        return this.options.titleBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBgColorIsThemeColor", false)
      }
    },
    titleBgColor: {
      get() {
        return this.options.titleBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBgColor", false)
      }
    },
    topSelectBgColorIsThemeColor: {
      get() {
        return this.options.topSelectBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topSelectBgColorIsThemeColor", false)
      }
    },
    topSelectBgColor: {
      get() {
        return this.options.topSelectBgColor || "#363b5d"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topSelectBgColor", false)
      }
    },
    // 标题边距
    titlePaddingTypeFlag: {
      get() {
        let defaultType = 2
        if (((this.titlePaddingTop === this.titlePaddingRight) === this.titlePaddingLeft) === this.titlePaddingBottom) {
          defaultType = 1
        }
        return this.options.titlePaddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingTypeFlag", false)
      }
    },
    titlePadding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titlePadding", "titlePadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePadding", false)
      }
    },
    titlePaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titlePaddingTop", "titlePaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingTop", false)
      }
    },
    titlePaddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titlePaddingRight", "titlePaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingRight", false)
      }
    },
    titlePaddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titlePaddingLeft", "titlePaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingLeft", false)
      }
    },
    titlePaddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "titlePaddingBottom", "titlePaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingBottom", false)
      }
    },
    showLunar: {
      get() {
        return this.options.showLunar || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showLunar", false)
      }
    },
    firstDayOfWeek: {
      get() {
        if (this.options.firstDayOfWeek == 7) {
          this.activeStart = "start0"
        } else {
          this.activeStart = "start1"
        }
        return this.options.firstDayOfWeek || 7
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "firstDayOfWeek", false)
      }
    },
    weekColor: {
      get() {
        return this.options.weekColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "weekColor", false)
      }
    },
    weekFontFamily: {
      get() {
        return this.options.weekFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "weekFontFamily", false)
      }
    },
    weekFontSize: {
      get() {
        return this.options.weekFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "weekFontSize", false)
      }
    },
    weekFontWeight: {
      get() {
        return this.options.weekFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "weekFontWeight", false)
      }
    },
    weekBgColorIsThemeColor: {
      get() {
        return this.options.weekBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "weekBgColorIsThemeColor", false)
      }
    },
    weekBgColor: {
      get() {
        return this.options.weekBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "weekBgColor", false)
      }
    },
    lunarHoverColor: {
      get() {
        return this.options.lunarHoverColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lunarHoverColor", false)
      }
    },
    lunarHoverFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "lunarHoverFontFamily", "lunarHoverFontFamily", this.options.lunarFontFamily)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lunarHoverFontFamily", false)
      }
    },
    lunarHoverFontSize: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "lunarHoverFontSize", "lunarHoverFontSize", this.options.lunarFontSize)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lunarHoverFontSize", false)
      }
    },
    lunarHoverFontWeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "lunarHoverFontWeight", "lunarHoverFontWeight", this.options.lunarFontWeight)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lunarHoverFontWeight", false)
      }
    },
    lunarActiveColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "lunarActiveColor", "lunarActiveColor", this.options.lunarColor)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lunarActiveColor", false)
      }
    },
    lunarActiveFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "lunarActiveFontFamily", "lunarActiveFontFamily", this.options.lunarFontFamily)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lunarActiveFontFamily", false)
      }
    },
    lunarActiveFontSize: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "lunarActiveFontSize", "lunarActiveFontSize", this.options.lunarFontSize)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lunarActiveFontSize", false)
      }
    },
    lunarActiveFontWeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "lunarActiveFontWeight", "lunarActiveFontWeight", this.options.lunarFontWeight)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lunarActiveFontWeight", false)
      }
    },
    lunarColor: {
      get() {
        return this.options.lunarColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lunarColor", false)
      }
    },
    lunarFontFamily: {
      get() {
        return this.options.lunarFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lunarFontFamily", false)
      }
    },
    lunarFontSize: {
      get() {
        return this.options.lunarFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lunarFontSize", false)
      }
    },
    lunarFontWeight: {
      get() {
        return this.options.lunarFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lunarFontWeight", false)
      }
    },
    showNotCurrentDate: {
      get() {
        return this.options.showNotCurrentDate || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showNotCurrentDate", false)
      }
    },
    notCurrentTextIsThemeColor: {
      get() {
        return this.options.notCurrentTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "notCurrentTextIsThemeColor", false)
      }
    },
    notCurrentTextColor: {
      get() {
        return this.options.notCurrentTextColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "notCurrentTextColor", false)
      }
    },
    hoverColor: {
      get() {
        return this.options.hoverColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverColor", false)
      }
    },
    hoverFontFamily: {
      get() {
        return this.options.hoverFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontFamily", false)
      }
    },
    hoverFontSize: {
      get() {
        return this.options.hoverFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontSize", false)
      }
    },
    hoverFontWeight: {
      get() {
        return this.options.hoverFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontWeight", false)
      }
    },
    hoverBorderTypeFlag: {
      get() {
        return this.options.hoverBorderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderTypeFlag", false)
      }
    },
    hoverBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "hoverBorderRadius",
          "hoverBorderRadius",
          this.hoverBorderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.hoverBorderTypeFlag === 2) {
          this.hoverBorderTopLeftRadius = newVal
          this.hoverBorderTopRightRadius = newVal
          this.hoverBorderBottomRightRadius = newVal
          this.hoverBorderBottomLeftRadius = newVal
        }
        this.$changeOptionsEV(newVal, "hoverBorderRadius", false)
      }
    },
    hoverBorderTopLeftRadius: {
      get() {
        return this.options.hoverBorderTopLeftRadius || 0
      },
      set(newVal) {
        if (this.hoverBorderTypeFlag === 2) {
          this.$changeOptionsEV(
            [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
            [
              "hoverBorderTopRightRadius",
              "hoverBorderBottomRightRadius",
              "hoverBorderBottomLeftRadius",
              "hoverBorderTopLeftRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "hoverBorderTopLeftRadius", false)
        }
      }
    },
    hoverBorderTopRightRadius: {
      get() {
        return this.options.hoverBorderTopRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderTopRightRadius", false)
      }
    },
    hoverBorderBottomRightRadius: {
      get() {
        return this.options.hoverBorderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderBottomRightRadius", false)
      }
    },
    hoverBorderBottomLeftRadius: {
      get() {
        return this.options.hoverBorderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderBottomLeftRadius", false)
      }
    },
    hoverBgColorIsThemeColor: {
      get() {
        return this.options.hoverBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBgColorIsThemeColor", false)
      }
    },
    hoverBgColor: {
      get() {
        return this.options.hoverBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBgColor", false)
      }
    },
    hoverAllBgColorIsThemeColor: {
      get() {
        return this.options.hoverAllBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverAllBgColorIsThemeColor", false)
      }
    },
    hoverAllBgColor: {
      get() {
        return this.options.hoverAllBgColor || "rgba(0,0,0,0)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverAllBgColor", false)
      }
    },
    hoverBorderWidth: {
      get() {
        return this.options.hoverBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderWidth", false)
      }
    },
    hoverBorderStyle: {
      get() {
        return this.options.hoverBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderStyle", false)
      }
    },
    hoverBorderColor: {
      get() {
        return this.options.hoverBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderColor", false)
      }
    },
    showHoverBorder: {
      get() {
        return this.options.showHoverBorder
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showHoverBorder", false)
      }
    },
    hoverBorderIsThemeColor: {
      get() {
        return this.options.hoverBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderIsThemeColor", false)
      }
    },

    activeColor: {
      get() {
        return this.options.activeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeColor", false)
      }
    },
    activeFontFamily: {
      get() {
        return this.options.activeFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontFamily", false)
      }
    },
    activeFontSize: {
      get() {
        return this.options.activeFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontSize", false)
      }
    },
    activeFontWeight: {
      get() {
        return this.options.activeFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontWeight", false)
      }
    },
    activeBorderTypeFlag: {
      get() {
        return this.options.activeBorderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderTypeFlag", false)
      }
    },
    activeBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "activeBorderRadius",
          "activeBorderRadius",
          this.activeBorderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.activeBorderTypeFlag === 2) {
          this.activeBorderTopLeftRadius = newVal
          this.activeBorderTopRightRadius = newVal
          this.activeBorderBottomRightRadius = newVal
          this.activeBorderBottomLeftRadius = newVal
        }
        this.$changeOptionsEV(newVal, "activeBorderRadius", false)
      }
    },
    activeBorderTopLeftRadius: {
      get() {
        return this.options.activeBorderTopLeftRadius || 0
      },
      set(newVal) {
        if (this.activeBorderTypeFlag === 2) {
          this.$changeOptionsEV(
            [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
            [
              "activeBorderTopRightRadius",
              "activeBorderBottomRightRadius",
              "activeBorderBottomLeftRadius",
              "activeBorderTopLeftRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "activeBorderTopLeftRadius", false)
        }
      }
    },
    activeBorderTopRightRadius: {
      get() {
        return this.options.activeBorderTopRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderTopRightRadius", false)
      }
    },
    activeBorderBottomRightRadius: {
      get() {
        return this.options.activeBorderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderBottomRightRadius", false)
      }
    },
    activeBorderBottomLeftRadius: {
      get() {
        return this.options.activeBorderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderBottomLeftRadius", false)
      }
    },
    activeBgColorIsThemeColor: {
      get() {
        return this.options.activeBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBgColorIsThemeColor", false)
      }
    },
    activeBgColor: {
      get() {
        return this.options.activeBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBgColor", false)
      }
    },
    activeAllBgColorIsThemeColor: {
      get() {
        return this.options.activeAllBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeAllBgColorIsThemeColor", false)
      }
    },
    activeAllBgColor: {
      get() {
        return this.options.activeAllBgColor || "rgba(0,0,0,0)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeAllBgColor", false)
      }
    },
    activeBorderWidth: {
      get() {
        return this.options.activeBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderWidth", false)
      }
    },
    activeBorderStyle: {
      get() {
        return this.options.activeBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderStyle", false)
      }
    },
    activeBorderColor: {
      get() {
        return this.options.activeBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderColor", false)
      }
    },
    activeBorderIsThemeColor: {
      get() {
        return this.options.activeBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderIsThemeColor", false)
      }
    },
    showActiveBorder: {
      get() {
        return this.options.showActiveBorder
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showActiveBorder", false)
      }
    },

    datePaddingTopVal: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "datePaddingTopVal", "datePaddingTopVal", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "datePaddingTopVal", false)
      }
    },
    datePaddingBottomVal: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "datePaddingBottomVal", "datePaddingBottomVal", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "datePaddingBottomVal", false)
      }
    },

    showTodayStyle: {
      get() {
        return this.options.showTodayStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showTodayStyle", false)
      }
    },
    todayStyleColor: {
      get() {
        return this.options.todayStyleColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayStyleColor", false)
      }
    },
    todayStyleFontFamily: {
      get() {
        return this.options.todayStyleFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayStyleFontFamily", false)
      }
    },
    todayStyleFontSize: {
      get() {
        return this.options.todayStyleFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayStyleFontSize", false)
      }
    },
    todayStyleFontWeight: {
      get() {
        return this.options.todayStyleFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayStyleFontWeight", false)
      }
    },
    todayStyleBorderTypeFlag: {
      get() {
        return this.options.todayStyleBorderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayStyleBorderTypeFlag", false)
      }
    },
    todayStyleBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "todayStyleBorderRadius",
          "todayStyleBorderRadius",
          this.todayStyleBorderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.todayStyleBorderTypeFlag === 2) {
          this.todayStyleBorderTopLeftRadius = newVal
          this.todayStyleBorderTopRightRadius = newVal
          this.todayStyleBorderBottomLeftRadius = newVal
          this.todayStyleBorderBottomRightRadius = newVal
        }
        this.$changeOptionsEV(newVal, "todayStyleBorderRadius", false)
      }
    },
    todayStyleBorderTopLeftRadius: {
      get() {
        return this.options.todayStyleBorderTopLeftRadius || 0
      },
      set(newVal) {
        if (this.todayStyleBorderTypeFlag === 2) {
          this.$changeOptionsEV(
            [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
            [
              "todayStyleBorderTopRightRadius",
              "todayStyleBorderBottomRightRadius",
              "todayStyleBorderBottomLeftRadius",
              "todayStyleBorderTopLeftRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "todayStyleBorderTopLeftRadius", false)
        }
      }
    },
    todayStyleBorderTopRightRadius: {
      get() {
        return this.options.todayStyleBorderTopRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayStyleBorderTopRightRadius", false)
      }
    },
    todayStyleBorderBottomRightRadius: {
      get() {
        return this.options.todayStyleBorderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayStyleBorderBottomRightRadius", false)
      }
    },
    todayStyleBorderBottomLeftRadius: {
      get() {
        return this.options.todayStyleBorderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayStyleBorderBottomLeftRadius", false)
      }
    },
    todayStyleBorderWidth: {
      get() {
        return this.options.todayStyleBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayStyleBorderWidth", false)
      }
    },
    todayStyleBorderStyle: {
      get() {
        return this.options.todayStyleBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayStyleBorderStyle", false)
      }
    },
    todayStyleBorderColor: {
      get() {
        return this.options.todayStyleBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayStyleBorderColor", false)
      }
    },
    todayStyleBorderIsThemeColor: {
      get() {
        return this.options.todayStyleBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayStyleBorderIsThemeColor", false)
      }
    },
    todayStyleBgColor: {
      get() {
        return this.options.todayStyleBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayStyleBgColor", false)
      }
    },
    todayStyleBgColorIsThemeColor: {
      get() {
        return this.options.todayStyleBgColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayStyleBgColorIsThemeColor", false)
      }
    },
    todayAllBgColor: {
      get() {
        return this.options.todayAllBgColor || "rgba(0,0,0,0)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayAllBgColor", false)
      }
    },
    todayAllBgColorIsThemeColor: {
      get() {
        return this.options.todayAllBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayAllBgColorIsThemeColor", false)
      }
    },
    showTodayStyleBorder: {
      get() {
        return this.options.showTodayStyleBorder
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showTodayStyleBorder", false)
      }
    },

    showActivityMark: {
      get() {
        return this.options.showActivityMark
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showActivityMark", false)
      }
    },
    activityWidth: {
      get() {
        return this.options.activityWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityWidth", false)
      }
    },
    activityColor: {
      get() {
        return this.options.activityColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityColor", false)
      }
    },
    activityColorIsThemeColor: {
      get() {
        return this.options.activityColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityColorIsThemeColor", false)
      }
    },
    activityFontColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activityFontColor", "activityFontColor", this.color)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityFontColor", false)
      }
    },
    activityFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activityFontFamily", "activityFontFamily", this.fontFamily)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityFontFamily", false)
      }
    },
    activityFontSize: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activityFontSize", "activityFontSize", 12)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityFontSize", false)
      }
    },
    activityFontWeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activityFontWeight", "activityFontWeight", this.fontWeight)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityFontWeight", false)
      }
    },
    activityBorderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activityBorderWidth", "activityBorderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityBorderWidth", false)
      }
    },
    activityBorderStyle: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activityBorderStyle", "activityBorderStyle", "solid")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityBorderStyle", false)
      }
    },
    activityBorderColor: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "activityBorderColor",
          "activityBorderColor",
          "rgba(0, 0, 0, 0)"
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityBorderColor", false)
      }
    },
    activityBorderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "activityBorderIsThemeColor",
          "activityBorderIsThemeColor",
          false
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityBorderIsThemeColor", false)
      }
    },
    activityBorderTypeFlag: {
      get() {
        return this.options.activityBorderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityBorderTypeFlag", false)
      }
    },
    activityBorderRadius: {
      get() {
        return this.options.activityBorderRadius
      },
      set(newVal) {
        if (this.activityBorderTypeFlag === 2) {
          this.activityBorderTopLeftRadius = newVal
          this.activityBorderTopRightRadius = newVal
          this.activityBorderBottomRightRadius = newVal
          this.activityBorderBottomLeftRadius = newVal
        }
        this.$changeOptionsEV(newVal, "activityBorderRadius", false)
      }
    },
    activityBorderTopLeftRadius: {
      get() {
        console.log("this.activeBorderTopLeftRadius :>>", this.activeBorderTopLeftRadius)

        return this.checkAndSetPrimaryVal(
          this.options,
          "activityBorderTopLeftRadius",
          "activityBorderTopLeftRadius",
          this.activeBorderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.activityBorderTypeFlag === 2) {
          this.$changeOptionsEV(
            [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
            [
              "activityBorderTopRightRadius",
              "activityBorderBottomRightRadius",
              "activityBorderBottomLeftRadius",
              "activityBorderTopLeftRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "activityBorderTopLeftRadius", false)
        }
      }
    },
    activityBorderTopRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "activityBorderTopLeftRadius",
          "activityBorderTopLeftRadius",
          this.activeBorderTopRightRadius
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityBorderTopRightRadius", false)
      }
    },
    activityBorderBottomRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "activityBorderTopLeftRadius",
          "activityBorderTopLeftRadius",
          this.activeBorderBottomRightRadius
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityBorderBottomRightRadius", false)
      }
    },
    activityBorderBottomLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "activityBorderTopLeftRadius",
          "activityBorderTopLeftRadius",
          this.activeBorderBottomLeftRadius
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityBorderBottomLeftRadius", false)
      }
    },
    activityBgColorIsThemeColor: {
      get() {
        return this.options.activityBgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityBgColorIsThemeColor", false)
      }
    },
    activityBgColor: {
      get() {
        return this.options.activityBgColor || "rgba(0, 0, 0, 0)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityBgColor", false)
      }
    },
    activeMark: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeMark", "activeMark", "type0")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeMark", false)
      }
    },

    //样式2下拉框
    selectlistsHeight: {
      get() {
        return this.options.selectlistsHeight || 200
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectlistsHeight", false)
      }
    },
    selectOptionsHeight: {
      get() {
        return this.options.selectOptionsHeight || 34
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectOptionsHeight", false)
      }
    },

    titleBorderTypeFlag: {
      get() {
        return this.options.titleBorderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBorderTypeFlag", false)
      }
    },
    titleBorderRadius: {
      get() {
        return this.options.titleBorderRadius || this.titleBorderTopLeftRadius
      },
      set(newVal) {
        if (this.titleBorderTypeFlag === 2) {
          this.titleBorderTopLeftRadius = newVal
          this.titleBorderTopRightRadius = newVal
          this.titleBorderBottomLeftRadius = newVal
          this.titleBorderBottomRightRadius = newVal
        }
        this.$changeOptionsEV(newVal, "titleBorderRadius", false)
      }
    },
    titleBorderTopLeftRadius: {
      get() {
        return this.options.titleBorderTopLeftRadius || 0
      },
      set(newVal) {
        if (this.titleBorderTypeFlag === 2) {
          this.$changeOptionsEV(
            [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
            [
              "titleBorderTopRightRadius",
              "titleBorderBottomRightRadius",
              "titleBorderBottomLeftRadius",
              "titleBorderTopLeftRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "titleBorderTopLeftRadius", false)
        }
      }
    },
    titleBorderTopRightRadius: {
      get() {
        return this.options.titleBorderTopRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBorderTopRightRadius", false)
      }
    },
    titleBorderBottomRightRadius: {
      get() {
        return this.options.titleBorderBottomRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBorderBottomRightRadius", false)
      }
    },
    titleBorderBottomLeftRadius: {
      get() {
        return this.options.titleBorderBottomLeftRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBorderBottomLeftRadius", false)
      }
    },
    titleBorderWidth: {
      get() {
        return this.options.titleBorderWidth || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBorderWidth", false)
      }
    },
    titleBorderStyle: {
      get() {
        return this.options.titleBorderStyle || "solid"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBorderStyle", false)
      }
    },
    titleBorderColor: {
      get() {
        return this.options.titleBorderColor || "transparent"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBorderColor", false)
      }
    },
    titleBorderIsThemeColor: {
      get() {
        return this.options.titleBorderIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBorderIsThemeColor", false)
      }
    },
    titleBoxShadowColor: {
      get() {
        return this.options.titleBoxShadowColor || "transparent"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBoxShadowColor", false)
      }
    },
    titleBoxShadowH: {
      get() {
        return this.options.titleBoxShadowH || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBoxShadowH", false)
      }
    },
    titleBoxShadowV: {
      get() {
        return this.options.titleBoxShadowV || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBoxShadowV", false)
      }
    },
    titleBoxShadowBlur: {
      get() {
        return this.options.titleBoxShadowBlur || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBoxShadowBlur", false)
      }
    },
    titleBoxShadowSpread: {
      get() {
        return this.options.titleBoxShadowSpread || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleBoxShadowSpread", false)
      }
    },
    // 边距
    titlePaddingTypeFlag2: {
      get() {
        let defaultType = 2
        if (
          ((this.titlePaddingTop2 === this.titlePaddingRight2) === this.titlePaddingLeft2) ===
          this.titlePaddingBottom2
        ) {
          defaultType = 1
        }
        return this.options.titlePaddingTypeFlag2 || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingTypeFlag2", false)
      }
    },
    titlePadding2: {
      get() {
        return this.options.titlePadding2 || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePadding2", false)
      }
    },
    titlePaddingTop2: {
      get() {
        return this.options.titlePaddingTop2 || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingTop2", false)
      }
    },
    titlePaddingRight2: {
      get() {
        return this.options.titlePaddingRight2 || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingRight2", false)
      }
    },
    titlePaddingLeft2: {
      get() {
        return this.options.titlePaddingLeft2 || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingLeft2", false)
      }
    },
    titlePaddingBottom2: {
      get() {
        return this.options.titlePaddingBottom2 || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titlePaddingBottom2", false)
      }
    },

    titleSelectColor: {
      get() {
        return this.options.titleSelectColor || "rgba(0,0,0,0)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleSelectColor", false)
      }
    },
    titleSelectFontFamily: {
      get() {
        return this.options.titleSelectFontFamily || this.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleSelectFontFamily", false)
      }
    },
    titleSelectFontSize: {
      get() {
        return this.options.titleSelectFontSize || 12
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleSelectFontSize", false)
      }
    },
    titleSelectFontWeight: {
      get() {
        return this.options.titleSelectFontWeight || 400
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleSelectFontWeight", false)
      }
    },
    titleSelectBgIsThemeColor: {
      get() {
        return this.options.titleSelectBgIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleSelectBgIsThemeColor", false)
      }
    },
    titleSelectBgColor: {
      get() {
        return this.options.titleSelectBgColor || "#363B5D"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleSelectBgColor", false)
      }
    },
    titleSelectOptionsBgIsThemeColor: {
      get() {
        return this.options.titleSelectOptionsBgIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleSelectOptionsBgIsThemeColor", false)
      }
    },
    titleSelectOptionsBgColor: {
      get() {
        return this.options.titleSelectOptionsBgColor || "#363B5D"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleSelectOptionsBgColor", false)
      }
    },
    titleSelectActiveColor: {
      get() {
        return this.options.titleSelectActiveColor || "rgba(0,0,0,0)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleSelectActiveColor", false)
      }
    },
    titleSelectActiveFontFamily: {
      get() {
        return this.options.titleSelectActiveFontFamily || this.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleSelectActiveFontFamily", false)
      }
    },
    titleSelectActiveFontSize: {
      get() {
        return this.options.titleSelectActiveFontSize || 12
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleSelectActiveFontSize", false)
      }
    },
    titleSelectActiveFontWeight: {
      get() {
        return this.options.titleSelectActiveFontWeight || 400
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleSelectActiveFontWeight", false)
      }
    },
    titleSelectActiveBgIsThemeColor: {
      get() {
        return this.options.titleSelectActiveBgIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleSelectActiveBgIsThemeColor", false)
      }
    },
    titleSelectActiveBgColor: {
      get() {
        return this.options.titleSelectActiveBgColor || "rgba(0,0,0,0)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "titleSelectActiveBgColor", false)
      }
    },
    activityLocation: {
      get() {
        return this.options.activityLocation || "5"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityLocation", false)
      }
    },
    selectWidth: {
      get() {
        return this.options.selectWidth || 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectWidth", false)
      }
    },

  //  新增样式3的设置项
    columnMargin: {
      get() {
        return this.options.columnMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "columnMargin", false)
      }
    },
    showDayBorder: {
      get() {
        return this.options.showDayBorder
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showDayBorder", false)
      }
    },
    dayBorderColor: {
      get() {
        return this.options.dayBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dayBorderColor", false)
      }
    },
    dayBorderIsThemeColor: {
      get() {
        return this.options.dayBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dayBorderIsThemeColor", false)
      }
    },
    dayBgColor: {
      get() {
        return this.options.dayBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dayBgColor", false)
      }
    },
    dayBgColorIsThemeColor: {
      get() {
        return this.options.dayBgColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dayBgColorIsThemeColor", false)
      }
    },
    dayBorderTypeFlag: {
      get() {
        return this.options.dayBorderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dayBorderTypeFlag", false)
      }
    },
    dayBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
            this.options,
            "dayBorderRadius",
            "dayBorderRadius",
            this.dayBorderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.dayBorderTypeFlag === 2) {
          this.dayBorderTopLeftRadius = newVal
          this.dayBorderTopRightRadius = newVal
          this.dayBorderBottomRightRadius = newVal
          this.dayBorderBottomLeftRadius = newVal
        }
        this.$changeOptionsEV(newVal, "dayBorderRadius", false)
      }
    },
    dayBorderTopLeftRadius: {
      get() {
        return this.options.dayBorderTopLeftRadius
      },
      set(newVal) {
        if (this.dayBorderTypeFlag === 2) {
          this.$changeOptionsEV(
              [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
              [
                "dayBorderTopRightRadius",
                "dayBorderBottomRightRadius",
                "dayBorderBottomLeftRadius",
                "dayBorderTopLeftRadius"
              ],
              false
          )
        } else {
          this.$changeOptionsEV(newVal, "dayBorderTopLeftRadius", false)
        }
      }
    },
    dayBorderTopRightRadius: {
      get() {
        return this.options.dayBorderTopRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dayBorderTopRightRadius", false)
      }
    },
    dayBorderBottomRightRadius: {
      get() {
        return this.options.dayBorderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dayBorderBottomRightRadius", false)
      }
    },
    dayBorderBottomLeftRadius: {
      get() {
        return this.options.dayBorderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dayBorderBottomLeftRadius", false)
      }
    },
    todayLunarType: {
      get() {
        if (this.options.todayLunarType === 1) {
          this.activeStart = "start0"
        } else if(this.options.todayLunarType === 2){
          this.activeStart = "start1"
        } else {
          this.activeStart = "start2"
        }
        return this.options.todayLunarType || 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLunarType", false)
      }
    },
    selfLunarTxt: {
      get() {
        return this.options.selfLunarTxt || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selfLunarTxt", false)
      }
    },
    todayLunarStyleColor: {
      get() {
        return this.options.todayLunarStyleColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLunarStyleColor", false)
      }
    },
    todayLunarStyleFontFamily: {
      get() {
        return this.options.todayLunarStyleFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLunarStyleFontFamily", false)
      }
    },
    todayLunarStyleFontSize: {
      get() {
        return this.options.todayLunarStyleFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLunarStyleFontSize", false)
      }
    },
    todayLunarStyleFontWeight: {
      get() {
        return this.options.todayLunarStyleFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLunarStyleFontWeight", false)
      }
    },
    activityLocation3: {
      get() {
        return this.options.activityLocation3 || "bottom"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityLocation3", false)
      }
    },
    activityLeft: {
      get() {
        return this.options.activityLeft || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityLeft", false)
      }
    },
    activityRight: {
      get() {
        return this.options.activityRight || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityRight", false)
      }
    },
    activityTop: {
      get() {
        return this.options.activityTop || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityTop", false)
      }
    },
    activityBottom: {
      get() {
        return this.options.activityBottom || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityBottom", false)
      }
    },
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
    this.isAdmin = this.$store.state.states.managerType === 1 ? true : false
    if (this.styleId === 2) {
      this.activityMaxWidth = 50
    }
  },
  methods: {
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    changeStartFn() {
      if (this.activeStart == "start0") {
        this.options.firstDayOfWeek = 7
      } else {
        this.options.firstDayOfWeek = 1
      }
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    titleAddBoxshadow() {
      if (!Array.isArray(this.titleBoxShadowH)) {
        this.titleBoxShadowH = [this.titleBoxShadowH]
        this.titleBoxShadowV = [this.titleBoxShadowV]
        this.titleBoxShadowBlur = [this.titleBoxShadowBlur]
        this.titleBoxShadowSpread = [this.titleBoxShadowSpread]
        this.titleBoxShadowColor = [this.titleBoxShadowColor]
      }
      let titleBoxShadowH = JSON.parse(JSON.stringify(this.titleBoxShadowH))
      let titleBoxShadowV = JSON.parse(JSON.stringify(this.titleBoxShadowV))
      let titleBoxShadowBlur = JSON.parse(JSON.stringify(this.titleBoxShadowBlur))
      let titleBoxShadowSpread = JSON.parse(JSON.stringify(this.titleBoxShadowSpread))
      let titleBoxShadowColor = JSON.parse(JSON.stringify(this.titleBoxShadowColor))
      titleBoxShadowH.push(0)
      titleBoxShadowV.push(4)
      titleBoxShadowBlur.push(4)
      titleBoxShadowSpread.push(0)
      titleBoxShadowColor.push("rgba(0,0,0,0.25)")
      this.titleBoxShadowH = titleBoxShadowH
      this.titleBoxShadowV = titleBoxShadowV
      this.titleBoxShadowBlur = titleBoxShadowBlur
      this.titleBoxShadowSpread = titleBoxShadowSpread
      this.titleBoxShadowColor = titleBoxShadowColor
    },
    changeLunarFn() {
      if (this.activeLunar === "start0") {
        this.options.todayLunarType = 1
      } else if(this.activeLunar === "start1"){
        this.options.todayLunarType = 2
      } else {
        this.options.todayLunarType = 3
      }
    }
  }
})
</script>

<style scoped lang="scss">
.custom-title-color {
  width: calc(100% - 76px);
}
.firstDayOfWeek-set {
  width: 100%;
}
.firstDayOfWeek-set .el-tabs {
  display: inline-block;
  width: calc(100% - 60px);
  vertical-align: middle;
}
::v-deep .firstDayOfWeek-set .el-tabs .el-tabs__header {
  margin: 0;
}
::v-deep .firstDayOfWeek-set .el-tabs .el-tabs__content {
  display: none;
}

::v-deep .date-state-set .el-tabs__content {
  padding-bottom: 0;
}
::v-deep .acvtivity-box .small-width.slider_and_input {
  width: calc(100% - 45px);
}
.acvtivity-box.el-tabs ::v-deep.el-tabs__header {
  margin-bottom: 16px;
}
.acvtivity-box.el-tabs ::v-deep.el-tabs__content {
  padding-bottom: 0;
}
.calendar-options-setting::v-deep .el-tabs__item {
  line-height: 32px;
}
.calendar-options-setting::v-deep .el-tabs__active-bar {
  height: 26px;
}
.calendar-options-setting::v-deep .el-tabs__item.is-active {
  color: var(--themeColor) !important;
  line-height: 32px;
  font-weight: normal;
}
.calendar-options-setting::v-deep .el-tabs__header {
  margin: 0;
}
.calendar-options-setting::v-deep .date-border-box {
  background: #fbfcfd;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  padding: 12px;
}
.padding12 {
  padding: 12px;
}
.widthPer77 {
  width: 77%;
}
.activity-location-select {
  width: calc(100% - 51px);
}
.content-item-2 {
  background-color: var(--cardBgColor);
  border: 1px solid var(--borderColorFour);
}
.custom-title-color.custom-title-color-card {
  width: calc(100% - 58px);
}
::v-deep .todayLunarType-set{
  .el-tabs {
    .el-tabs__header{
      margin: 0;
    }
    .el-tabs__content {
      display: none;
    }
  }
}
</style>
